import React from 'react';
import { Link } from 'react-router-dom';
import { getAuthor, initialenVan } from '../../data/authors';
import { themaVan, kaartBeeld } from '../../utils/kennisbank';
import { artikelPad } from '../../content/site/paden';
import { kennisbankTeksten, auteurInTaal } from '../../content/paginas/kennisbank';

export function formatDatum(dateStr, lang = 'nl') {
  return new Date(dateStr).toLocaleDateString(kennisbankTeksten(lang).datumLocale, { day: 'numeric', month: 'short', year: 'numeric' }).replace('.', '');
}

// In het Engels: de artikelen zelf blijven Nederlands, dat zeggen we erbij.
export function ArtikelInNl({ lang }) {
  if (lang !== 'en') return null;
  return <span className="kb-taal-label">{kennisbankTeksten(lang).artikelInNl}</span>;
}

// Foto van de auteur, of de initialen als er (nog) geen foto is.
export function AuteurAvatar({ author, className = 'kb-avatar' }) {
  if (author.photo) {
    return <img src={author.photo} alt="" className={className} loading="lazy" />;
  }
  return <span className={`${className} kb-avatar-initialen`} aria-hidden="true">{initialenVan(author)}</span>;
}

export function ThemaLabel({ artikel, lang = 'nl' }) {
  const thema = themaVan(artikel);
  return (
    <span className="kb-thema">
      <span className="kb-thema-stip" style={{ background: thema.kleur }} />
      {lang === 'en' ? kennisbankTeksten(lang).themas[thema.id] : thema.naam}
    </span>
  );
}

// Eén kaart in de kennisbank. `groot` = het uitgelichte, nieuwste artikel bovenaan.
// De hero-afbeelding toont zelf al de categorie, dus geen tweede label eroverheen.
// lang='en': link naar /en/knowledge-base/<slug> en het label "Article in Dutch";
// titel en samenvatting blijven Nederlands (lang="nl" voor screenreaders).
function KennisbankKaart({ artikel, groot = false, lang = 'nl' }) {
  const author = auteurInTaal(getAuthor(artikel.author), lang);
  const nl = lang === 'en' ? { lang: 'nl' } : {};
  return (
    <Link to={artikelPad(artikel.slug, lang)} className={`kb-kaart${groot ? ' kb-kaart-groot' : ''}`}>
      <div className="kb-kaart-beeld">
        {artikel.image && (
          <img
            src={kaartBeeld(artikel.image)}
            alt=""
            loading={groot ? 'eager' : 'lazy'}
            width="720"
            height="378"
          />
        )}
      </div>
      <div className="kb-kaart-tekst">
        <ThemaLabel artikel={artikel} lang={lang} />
        <ArtikelInNl lang={lang} />
        {groot ? (
          <h2 className="kb-kaart-titel" {...nl}>{artikel.title}</h2>
        ) : (
          <h3 className="kb-kaart-titel" {...nl}>{artikel.title}</h3>
        )}
        <p className="kb-kaart-samenvatting" {...nl}>{artikel.excerpt}</p>
        <div className="kb-kaart-meta">
          <AuteurAvatar author={author} />
          <span className="kb-kaart-auteur">{author.name}</span>
          <span className="kb-punt" />
          <span>{formatDatum(artikel.date, lang)}</span>
          <span className="kb-punt" />
          <span>{artikel.readTime}</span>
        </div>
      </div>
    </Link>
  );
}

export default KennisbankKaart;
